/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Grid, Container, Typography, Box, Tab, Tabs } from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import PropTypes from 'prop-types';
import { entityEnum } from '../../../constants/globalConstants';
import useCommunityList from '../../../hooks/useCommunityList';
import EmptyState from './EmptyState/EmptyState';
import '../Main.style.css';
import Pagination from '@material-ui/lab/Pagination';
import CommunityCard from './CommunityCard/CommunityCard';
import CardLoader from '../../../components/CardLoader/CardLoader';
import CommunityListSearch from './CommunityListSearch/CommunityListSearch';
import { isNumber } from 'lodash';
import { normalizeSearchText } from '@utils/Helper';
import { useLocation, useNavigate } from 'react-router-dom';

const options = ['Filter 1', 'Filter 2', 'Filter 3', 'Filter 4'];
const ITEM_HEIGHT = 48;
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon color="primary" fontSize="small" />;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function tabProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

// --- URL Query Param Helpers for Filter Persistence ---
// Strips keys that match the default so only changed values are encoded.
const stripDefaults = (where, defaults) => {
  const slim = {};
  Object.keys(defaults).forEach((key) => {
    const val = where[key];
    const def = defaults[key];
    if (Array.isArray(def)) {
      if (val && val.length > 0) slim[key] = val;
    } else if (typeof def === 'boolean') {
      if (val !== def) slim[key] = val;
    } else if ((key === 'minPopulation' || key === 'maxPopulation') && val !== -1) {
      slim[key] = val;
    }
  });
  return slim;
};

// Packs everything into a single Base64-encoded `f` query param.
const serializeFiltersToUrl = (where, searchedText, tabValue, page, intialWhereValue) => {
  const payload = {};
  if (tabValue !== 0) payload.t = tabValue;
  if (searchedText) payload.s = searchedText;
  if (page > 1) payload.p = page;

  const slim = stripDefaults(where, intialWhereValue);
  if (Object.keys(slim).length > 0) payload.w = slim;

  // Nothing changed → clean URL (no query string)
  if (Object.keys(payload).length === 0) return '';

  try {
    const json = JSON.stringify(payload);
    const encoded = btoa(unescape(encodeURIComponent(json)));
    return `f=${encodeURIComponent(encoded)}`;
  } catch (e) {
    console.error('Failed to encode filters', e);
    return '';
  }
};

const deserializeFiltersFromUrl = (searchStr, intialWhereValue, defaultTab) => {
  const params = new URLSearchParams(searchStr);
  const raw = params.get('f');

  if (!raw) {
    return { where: { ...intialWhereValue }, tab: defaultTab, search: '', page: 1 };
  }

  try {
    const json = decodeURIComponent(escape(atob(decodeURIComponent(raw))));
    const payload = JSON.parse(json);
    const tab = typeof payload.t === 'number' ? payload.t : defaultTab;
    const search = payload.s || '';
    const page = payload.p || 1;
    const where = { ...intialWhereValue, ...(payload.w || {}) };
    return { where, tab, search, page };
  } catch (e) {
    return { where: { ...intialWhereValue }, tab: defaultTab, search: '', page: 1 };
  }
};
// --- sessionStorage helpers ---
const STORAGE_KEY = 'communityListFilters';

const saveFilters = (where, search, tab, page, defaults) => {
  try {
    const slim = stripDefaults(where, defaults);
    const payload = {};
    if (tab !== 0) payload.t = tab;
    if (search) payload.s = search;
    if (page > 1) payload.p = page;
    if (Object.keys(slim).length > 0) payload.w = slim;

    if (Object.keys(payload).length === 0) {
      sessionStorage.removeItem(STORAGE_KEY);
    } else {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }
  } catch (e) {
    console.error(' saveFilters error:', e);
  }
};

const loadFilters = (defaults, defaultTab) => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const payload = JSON.parse(raw);
    return {
      where: { ...defaults, ...(payload.w || {}) },
      tab: typeof payload.t === 'number' ? payload.t : defaultTab,
      search: payload.s || '',
      page: payload.p || 1,
    };
  } catch (e) {
    return null;
  }
};
// --- End sessionStorage helpers ---

// --- End URL Query Param Helpers ---

const CommunityList = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [communityList, setCommunityList] = useState(null);
  const [userCommunities, setUserCommunities] = useState(null);
  const [favCommunities, setFavCommunities] = React.useState([]);
  const [recCommunities, setRecCommunities] = React.useState([]);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const intialWhereValue = {
    states: [],
    minPopulation: -1,
    maxPopulation: -1,
    amenitiesType: [],
    costOfLivingType: [],
    //transportation
    publicTransType: [],
    dedicatedWalkingPaths: false,
    dedicatedBikingPaths: false,
    localAirport: false,
    regionalAirport: false,
    //education
    publicType: false,
    privateType: false,
    faithBasedPrivate: false,
    specialNeedsPrivate: false,
    publicTechnicalJuniorCollege: false,
    privateTechnicalJuniorCollege: false,
    publicFourYearCollegeUniversity: false,
    privatecFourYearCollegeUniversity: false,
    homeschoolResourceGroups: false,
    charter: false,
    facilityType: [],
    clubsType: [],
  };

  // Parse initial state: URL first, then sessionStorage fallback
  const urlParsed = deserializeFiltersFromUrl(location.search, intialWhereValue, props?.tabValue);
  const hasUrlFilter = new URLSearchParams(location.search).has('f');
  const storageFallback = hasUrlFilter ? null : loadFilters(intialWhereValue, props?.tabValue);
  const initialFromUrl = hasUrlFilter ? urlParsed : storageFallback || urlParsed;

  const [where, setWhere] = React.useState(initialFromUrl.where);
  const [searchedText, setSearchedText] = useState(initialFromUrl.search);
  const [tabValue, setTabValue] = React.useState(initialFromUrl.tab);
  const { getAllCommunities, getCommunitiesByUser } = useCommunityList();
  let stateCommunitiesArr = [];
  let userCommunitiesArr = [];
  const favCommunitiesList = {};
  const recCommunitiesList = {};
  let filteredList = [];
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Pagination state (server-side)
  const [currentPage, setCurrentPage] = useState(initialFromUrl.page);
  const [itemsPerPage] = useState(12); // You can make this configurable if needed
  const [totalCount, setTotalCount] = useState(0);

  // Helper: update URL and sessionStorage with current filter state (replace, not push)
  const updateUrlParams = useCallback(
    (newWhere, newSearch, newTab, newPage) => {
      // Save to sessionStorage so filters survive navigation
      saveFilters(newWhere, newSearch, newTab, newPage, intialWhereValue);

      const searchString = serializeFiltersToUrl(
        newWhere,
        newSearch,
        newTab,
        newPage,
        intialWhereValue,
      );
      navigate(`${location.pathname}${searchString ? `?${searchString}` : ''}`, { replace: true });
    },
    [navigate, location.pathname],
  );

  // const classes = useStyles();
  const key = 'iFrasCwdJh';

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [userId] = useState(loggedInUserData?.id);

  const createFavListObject = () => {
    if (userId !== null && userId !== undefined) {
      const userCommunitiesObject = userCommunitiesArr.usersResult;
      const communityListByStateObject = stateCommunitiesArr.usersResult;

      if (userCommunitiesObject) {
        const mergeArr = [];
        if (communityListByStateObject !== undefined) {
          for (let i = 0; i < communityListByStateObject?.length; i += 1) {
            mergeArr.push({
              ...communityListByStateObject[i],
              ...userCommunitiesObject.find(
                (itmInner) => itmInner.communityMapId.id === communityListByStateObject[i].id,
              ),
            });
          }
        }

        if (mergeArr?.length > 0) {
          mergeArr.forEach((elem) => {
            recCommunitiesList[
              `${elem?.communityMapId?.id === undefined ? elem?.id : elem?.communityMapId?.id}`
            ] = elem.isRecommended !== undefined ? Boolean(elem.isRecommended) : false;
            favCommunitiesList[
              `${elem?.communityMapId?.id === undefined ? elem?.id : elem?.communityMapId?.id}`
            ] = elem.isFavourite !== undefined ? Boolean(elem.isFavourite) : false;
          });
        }
        setFavCommunities(favCommunitiesList);
        setRecCommunities(recCommunitiesList);
      }
    }
    return favCommunitiesList;
  };

  const communityFilterFunction = (communityArray, _tabValue, searchedTextParam, _where = null) => {
    switch (_tabValue) {
      case 0: {
        filteredList = communityArray;
        break;
      }
      case 1: {
        if (userCommunities !== null && userCommunities?.length > 0) {
          const userCommObj = userCommunities.reduce(
            (acc, cur) => ({ ...acc, [cur?.communityMapId?.id]: cur?.readAt }),
            {},
          );

          communityArray
            .sort((a, b) => {
              return (
                new Date(userCommObj[b.id] || '1900-01-01') -
                new Date(userCommObj[a.id] || '1900-01-01')
              );
            })
            .forEach((clbs) => {
              if (userCommObj[clbs?.id] !== undefined) {
                /* eslint-disable no-param-reassign */
                clbs.readAt = userCommObj[clbs?.id];
                /* eslint-enable no-param-reassign */
              }
            });

          filteredList = communityArray;
        }
        break;
      }
      case 2: {
        if (userCommunities !== null && userCommunities?.length > 0) {
          filteredList = communityArray.filter((clbs) => favCommunities[clbs.id] === true);
        }

        break;
      }
      case 3: {
        if (userCommunities !== null && userCommunities?.length > 0) {
          filteredList = communityArray.filter((clbs) => {
            return recCommunities[clbs.id] === true;
          });
        }
        break;
      }
      default: {
        break;
      }
    }

    filteredList = filteredList?.filter((clbs) => {
      return (
        clbs?.communityNameText?.toLowerCase().indexOf(searchedTextParam.toLowerCase()) !== -1 ||
        clbs?.stateCommunities?.stateName
          ?.toLowerCase()
          .indexOf(searchedTextParam.toLowerCase()) !== -1
      );
    });
    setFilteredData(filteredList);
    // return filteredList;
  };

  const fillCommunityList = async (
    _where = null,
    _tabValue = tabValue,
    searchText = null,
    page = currentPage,
  ) => {
    setIsLoading(true);
    const states = (_where || where || [])?.states?.map((s) => (isNumber(s) ? s : s?.id));
    const hasFilterOrSearch = _where !== null || searchText !== null;
    const effectivePage = hasFilterOrSearch ? 1 : page;
    const payload = {
      ...(_where || where),
      states,
      tab: _tabValue,
      searchText: (searchText !== null ? searchText : searchedText)?.trim(),
      userID: props.userID,
      page: effectivePage,
      limit: itemsPerPage,
    };

    const response = await getAllCommunities(payload);
    setCommunityList(response?.dataResult || []);
    setTotalCount(response?.count || 0);
    setIsLoading(false);
  };

  const fillUserCommunities = async () => {
    if (userId !== null && userId !== undefined) {
      if (userCommunitiesArr?.length === 0) {
        userCommunitiesArr = await getCommunitiesByUser({
          userId,
          typeText: entityEnum[0],
        });
        // createFavListObject();
        setUserCommunities(userCommunitiesArr?.usersResult);
      }
    }
    return userCommunitiesArr?.usersResult;
  };
  const callFilterFromChild = async () => {
    await fillCommunityList(null, tabValue);
    // await fillUserCommunities();
    /* 
    
    communityFilterFunction(communityList, tabValue, searchedText); */
  };

  const handleChange = async (_e, newValue) => {
    setIsLoading(true);
    setTabValue(newValue);
    setCommunityList(null);
    setFilteredData(null);
    setCurrentPage(1);
    updateUrlParams(where, searchedText, newValue, 1);
    setTimeout(async () => {
      if (
        newValue === 0 ||
        newValue === 1 ||
        (userId && newValue === 2) ||
        (userId && newValue === 3)
      ) {
        await fillCommunityList(null, newValue, null, 1);
      } else {
        setCommunityList([]);
        setTotalCount(0);
      }
      setIsLoading(false);
    }, 0);
  };

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSearchChange = (event) => {
    const searchText = normalizeSearchText(event?.target?.value);

    setSearchedText(searchText);

    // Clear existing debounce
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    // ❌ Do not refresh list if search is empty
    if (searchText === '') {
      return;
    }

    const newTimeout = setTimeout(() => {
      setCurrentPage(1);
      updateUrlParams(where, searchText, tabValue, 1);
      fillCommunityList(null, tabValue, searchText, 1);
    }, 500); // 500ms delay

    setDebounceTimeout(newTimeout);
  };

  const clearSearch = async () => {
    setSearchedText('');
    setCurrentPage(1);
    updateUrlParams(where, '', tabValue, 1);
    await fillCommunityList(null, tabValue, '', 1);
  };
  const handleFilterClose = () => {
    setAnchorEl(null);
  };
  const initialLoadDone = useRef(false);
  useEffect(() => {
    if (!initialLoadDone.current) {
      // On first mount, use URL-parsed values
      initialLoadDone.current = true;
      fillCommunityList(
        initialFromUrl.where,
        initialFromUrl.tab,
        initialFromUrl.search || '',
        initialFromUrl.page,
      );
    } else {
      fillCommunityList(null, tabValue); // Tushar changes @Faisal
    }
  }, [props]); // Tushar changes @Faisal

  useEffect(() => {
    // fillUserCommunities();
  }, []);

  useEffect(() => {
    // createFavListObject();
  }, []);

  return (
    <Box className="PageSpacing CommunityListPage">
      {props?.showSearch && (
        <>
          <Container>
            <Grid container direction="row">
              <Grid item xs={12}>
                <Typography variant="h1" className="PageTitle BlackColor">
                  Communities
                </Typography>
              </Grid>
            </Grid>
            <Box mb={2} mt={2}>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                aria-label="Communities Tabs"
                className="CommonTabNav"
              >
                <Tab label="All" tabValue={0} {...tabProps(0)} />
                <Tab label="Recent" tabValue={1} {...tabProps(1)} />
                <Tab label="Favorites" tabValue={2} {...tabProps(2)} />
                <Tab label="Recommended" tabValue={3} {...tabProps(3)} />
              </Tabs>
            </Box>

            <form>
              <CommunityListSearch
                searchedText={searchedText}
                clearSearch={clearSearch}
                handleFilterClose={handleFilterClose}
                handleSearchChange={handleSearchChange}
                open={open}
                anchorEl={anchorEl}
                handleFilterClick={handleFilterClick}
                intialWhereValue={intialWhereValue}
                currentWhere={where}
                setWhere={(newWhere) => {
                  setWhere(newWhere);
                  updateUrlParams(newWhere, searchedText, tabValue, 1);
                  setCurrentPage(1);
                }}
                fillCommunityList={fillCommunityList}
                communityList={communityList}
                tabValue={tabValue}
                allCommunities={communityList}
              />
              <Box mb={2} className="ResultNumber">
                <Typography variant="body2" component="div">
                  {totalCount}
                  <Box component="span" ml={1}>
                    {totalCount <= 1 ? 'Result' : 'Results'}
                  </Box>
                </Typography>
              </Box>
            </form>
          </Container>
        </>
      )}
      <Container>
        {
          /* communityList?.length > 0 && */
          isLoading ? (
            <CardLoader />
          ) : (
            <Grid container direction="row" justifyContent="flex-start" alignItems="stretch">
              {communityList?.length > 0 ? (
                <>
                  {(() => {
                    const totalPages = Math.ceil(totalCount / itemsPerPage) || 1;
                    const startIndex = (currentPage - 1) * itemsPerPage + 1;
                    const endIndex = Math.min(currentPage * itemsPerPage, totalCount);

                    return (
                      <>
                        {communityList.map((cm, index) =>
                          userId ? (
                            <CommunityCard
                              key={cm.id || index}
                              cm={cm}
                              tabValue={tabValue}
                              listView
                              callFilterFromChild={callFilterFromChild}
                              updateFavObject={fillCommunityList}
                            />
                          ) : (
                            <CommunityCard
                              key={cm.id || index}
                              cm={cm}
                              listView
                              updateFavObject={null}
                            />
                          ),
                        )}
                        <Grid container direction="row">
                          <Grid item xs={12}>
                            <Box className="PaginationWrapper BasicPagination">
                              <Typography
                                variant="body2"
                                component="span"
                                className="PaginationNumber"
                              >
                                <Box component="span">{startIndex}</Box>-
                                <Box component="span">{endIndex}</Box> of{' '}
                                <Box component="span">{totalCount}</Box> results
                              </Typography>
                              <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={(_, page) => {
                                  setCurrentPage(page);
                                  updateUrlParams(where, searchedText, tabValue, page);
                                  fillCommunityList(null, tabValue, null, page);
                                }}
                                color="primary"
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </>
                    );
                  })()}
                </>
              ) : communityList != null ? (
                <EmptyState tabValue={tabValue} />
              ) : (
                ''
              )}
            </Grid>
          )
        }
      </Container>
    </Box>
  );
};
CommunityList.defaultProps = {
  showSearch: true,
  tabValue: 0,
  userID: null,
};
export default CommunityList;
